import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { CtBinaryOperator, CtButtonConfiguration, CtControlService, CtControlTypes, CTDatatablePaginationParameter, CtFormConfiguration, CTGeneralService, CtModelConfiguration, CTModelDatatableFilter, CtModelDatatableOperators, CtModelOperator, CtModelService, CtSelectControlOptions, CtSelectControlValue, CtThemeTypes, MAT_RAISED_ACCENT, MAT_RAISED_WARN, MateriaHintExtensionConfig, MaterialControlOptions } from '@ctsolution/ct-framework';
import { CTMGeneralService } from '../../../_core/lib/general.service';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TaskRouteData } from '../../../_core/route-data/task.route-data';
import { WorkOrderRouteData } from '../../../_core/route-data/work-order.route-data';
import { TaskLeadRouteData } from '../../../_core/route-data/task-lead.route-data';
import { forkJoin, map, of, Subscription, switchMap, take } from 'rxjs';
import { Task } from '../../../_core/classes/task';
import { Task_Lead } from '../../../_core/classes/task_lead';
import { CtWebapiGenericResponse, DataRequest, MethodEnum } from '@ctsolution/ct-webapi';
import { isNil, omitBy } from 'lodash';
import { DEFAULT_DATATABLE_CONFIGURATION } from '../../../_core/constants';
import { TaskService } from '../task.service';
import { TaskLeadEditConfiguration } from '../task-lead-edit/task-lead-edit.configuration';
import { EventPathParam } from '../../../_core/classes/event-path-param';
import { TaskTypeRouteData } from '../../../_core/route-data/task-type.route-data';
import { TaskType } from '../../../_core/enum/task-type';
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { LeadSelectionComponent } from '../lead-selection/lead-selection.component';
import { CTConfigurationModel } from '../../../_core/classes/ct-configuration-model';
import { CtManagerService } from '../../../_core/lib/ct-manager.service';

@Component({
  selector: 'app-task-edit',
  templateUrl: './task-edit.component.html',
  styleUrls: ['./task-edit.component.scss']
})
export class TaskEditComponent implements AfterViewInit, OnDestroy {


  private typeControl = this.controlService.getDefaultConfiguration({
    name: 'Type',
    type: CtControlTypes.LOOKUP,
    remoteValueOptionsEndpoint: DataRequest.create()
      .setController(['TaskType'])
      .setAction('Lookup')
      .setMethod(MethodEnum.POST)
      .setQueryParams({ hideSpinner: true })
  }).setFlexSpacePercentage(50)
    .setTheme(CtThemeTypes.MATERIAL)
    .setRequired(true);

  private nameControl = this.generalService.getTextControl({
    name: 'Name',
    required: true
  }).setFlexSpacePercentage(50)
    .setLabel('Profile')


  private stateControl = this.generalService.getLookupControlDefaultConfiguration({
    name: 'State',
    controller: 'TaskState',
    type: CtControlTypes.ENUMERABLE,
    required: false
  }).setFlexSpacePercentage(25);

  //TODO: Creare enum

  private systemUserControl = this.controlService.getDefaultConfiguration({
    name: 'SystemUser',
    type: CtControlTypes.LOOKUP,
    remoteValueOptionsEndpoint: DataRequest.create()
      .setController(['User'])
      .setAction('Lookup')
      .setMethod(MethodEnum.POST)
  }).setFlexSpacePercentage(50)
    .setTheme(CtThemeTypes.MATERIAL)
    .setRequired(false)
    .setLabel('Selector');

  private workOrderControl = this.controlService.getDefaultConfiguration({
    name: 'WorkOrder',
    type: CtControlTypes.LOOKUP,
    remoteValueOptionsEndpoint: DataRequest.create()
      .setController(['WorkOrder'])
      .setAction('Lookup')
      .setMethod(MethodEnum.POST)
      .setQueryParams({ hideSpinner: true })
  }).setFlexSpacePercentage(50)
    .setTheme(CtThemeTypes.MATERIAL)
    .setRequired(false)
    .setLabel('ReferenceNameWorkOrderQuotation')

  private effortControl = this.controlService.getDefaultConfiguration({
    name: 'Effort',
    type: CtControlTypes.NUMBER,
  }).setFlexSpacePercentage(25);

  private startDateControl = this.generalService.getDateControlDefault({
    name: 'StartDate',
    required: false
  }).setFlexSpacePercentage(25)
    .setLabel('OrderDate');

  private endDateControl = this.generalService.getDateControlDefault({
    name: 'EndDate',
    required: false
  }).setFlexSpacePercentage(25);

  private descriptionControl = this.generalService.getTextControl({
    name: 'Description',
    required: false
  }).setType(CtControlTypes.TEXTAREA).setFlexSpacePercentage(100);

  private invoiceNumberControl = this.generalService.getTextControl({
    name: 'InvoiceNumber',
    required: false
  }).setFlexSpacePercentage(50);

  private invoiceStateControl = this.controlService.getDefaultConfiguration({
    name: 'State',
    type: CtControlTypes.ENUMERABLE,
    required: false
  }).setFlexSpacePercentage(33.33)
    .setValueOptions([
      CtSelectControlValue.create().setLabel('Non impostata').setValue(1),
      CtSelectControlValue.create().setLabel('Da inviare').setValue(2),
      CtSelectControlValue.create().setLabel('Inviata').setValue(3)
    ])

  private invoiceTotalControl = this.generalService.getTextControl({
    name: 'InvoiceTotal',
    required: false
  }).setFlexSpacePercentage(33.33);

  private invoiceVATControl = this.generalService.getTextControl({
    name: 'InvoiceVAT',
    required: false
  }).setFlexSpacePercentage(33.33);

  private invoiceDateControl = this.generalService.getDateControlDefault({
    name: 'InvoiceDate',
    required: false
  }).setFlexSpacePercentage(50);

  private invoiceCommentsControl = this.generalService.getTextControl({
    name: 'InvoiceComments',
    required: false
  }).setType(CtControlTypes.TEXTAREA).setFlexSpacePercentage(100);

  mainControls = [
    this.typeControl,
    this.nameControl,
    this.systemUserControl,
    this.workOrderControl,
    this.stateControl,
    this.effortControl,
    this.startDateControl,
    this.endDateControl,
    this.descriptionControl
  ]

  invoiceControls = [
    this.invoiceNumberControl,
    this.invoiceDateControl,
    this.invoiceStateControl,
    this.invoiceTotalControl,
    this.invoiceVATControl,
    this.invoiceCommentsControl
  ]


  mainConfiguration: CtFormConfiguration | null = null;
  invoiceConfiguration: CtFormConfiguration | null = null;

  /**
   * Configurazione client-specific del task edit. Risolta in `initialize()` via
   * `getComponentOverride("task", "taskConfiguration", ...)`.
   * Usata per governare la visibilità della sezione "Dati fatturazione" tramite
   * il flag `taskInvoiceSectionVisible`.
   */
  taskConfiguration: CTConfigurationModel = CTConfigurationModel.create();


  taskLeadConfigurations: CtFormConfiguration[] = [];
  taskLeadModelConfiguration: CtModelConfiguration<any> | null = null;
  isMasterDetail = false;
  
  /** OID del task corrente - utilizzato per il pulsante di clonazione */
  pId: number | null = null;

  cancelButton = CtButtonConfiguration.create()
    .setLabel("CT_PAGE.CT_FORM.cancel")
    .setAction(() => this.CTGeneralService.back())
    .setMatherialOptions(MAT_RAISED_WARN);

  submitButton = CtButtonConfiguration.create()
    .setLabel("CT_PAGE.CT_FORM.save")
    .setClass('ct-model-submit-button')
    .setAction(() => this.onSubmit())
    .setMatherialOptions(MAT_RAISED_ACCENT);

  addLeadButton = CtButtonConfiguration.create()
    .setLabel("Aggiungi candidato")
    .setClass('ct-model-submit-button')
    .setAction(() => this.addTaskLeadForm())
    .setMatherialOptions(MAT_RAISED_ACCENT);

  removeLeadButton = CtButtonConfiguration.create()
    .setLabel("Rimuovi")
    .setAction((event) => this.removeTaskLeadForm(event))
    .setMatherialOptions(MAT_RAISED_WARN);

  taskTypeSubscription?: Subscription;
  typeValue: TaskType | null = null;
  taskTypeList: Array<any> = [];
  TaskType = TaskType;

  constructor(
    private generalService: CTMGeneralService,
    private formBuilder: FormBuilder,
    private CTGeneralService: CTGeneralService,
    private route: ActivatedRoute,
    private modelService: CtModelService<any>,
    private taskService: TaskService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private dialog: MatDialog,
    private controlService: CtControlService,
    private managerService: CtManagerService
  ) { }

  ngAfterViewInit(): void {

    this.route.data.subscribe(data => data["title"] = "Task");

    this.initialize();
  }

  async initialize() {

    // Risolve l'override per-client (taskConfiguration.taskInvoiceSectionVisible)
    // PRIMA di costruire i form: setupMainForm decide se istanziare o meno
    // invoiceConfiguration in base al flag risolto.
    await this.managerService
      .getComponentOverride("task", "taskConfiguration", this.taskConfiguration);

    await this.setupMainForm();

    const pIdString = this.route.snapshot.paramMap.get("id");
    const workOrderOid = this.route.snapshot.queryParamMap.get('OidExtra'); //Ora do per scontato che si possa creare solo dai work order

    if (pIdString) {
      this.pId = +pIdString;
      this.setup(this.pId);
      this.isMasterDetail = true;
    }

    if (workOrderOid) this.setupWorkOrder(+workOrderOid);

    this.listenToTaskTypeChanges();

    this.syncListTaskType();

  }

  async setupMainForm() {
    //this.mainConfiguration = await this.generalService.getFormConfiguration(this.formBuilder.group({}), TaskRouteData());

    this.mainConfiguration = CtFormConfiguration.create(this.formBuilder.group({})).setControls(this.mainControls)

    // Sezione "Dati fatturazione" opzionale per-client: `invoiceConfiguration` viene
    // istanziato solo se `taskInvoiceSectionVisible === true`. Il default è `false`,
    // quindi la sezione è nascosta per tutti i client a meno che non venga abilitata
    // esplicitamente via `getComponentOverride("task", "taskConfiguration", ...)`.
    // Quando null, il template (`*ngIf="invoiceConfiguration"`) non renderizza né
    // il titolo né il <ct-form>.
    if (this.taskConfiguration.taskInvoiceSectionVisible) {
      this.invoiceConfiguration = CtFormConfiguration.create(this.formBuilder.group({})).setControls(this.invoiceControls);
    }

  }

  private syncListTaskType() {

    const taskTypeModelConfiguration = CtModelConfiguration.create().setRouteData(TaskTypeRouteData());

    const filter = CtModelDatatableOperators
      .create()
      .setPagination(new CTDatatablePaginationParameter())

    this.modelService.getList(taskTypeModelConfiguration, filter).subscribe((result: CtWebapiGenericResponse<any>) => {

      if (result.Result.DataSource && result.Result.DataSource.length) {

        this.taskTypeList = result.Result.DataSource;

      }

    })

  }

  setup(pid: number) {

    const modelConfiguration = CtModelConfiguration.create().setRouteData(TaskRouteData().setId(pid));

    this.modelService.getInfos(modelConfiguration).subscribe(response => {

        const dataSource: Task = response?.Result?.DataSource;


        if (dataSource && dataSource.Oid) {

          this.mainConfiguration?.form?.patchValue(dataSource, { emitEvent: true });
          this.invoiceConfiguration?.form?.patchValue(dataSource, { emitEvent: true });

          if (dataSource.WorkOrder) {

            const control = this.mainConfiguration?.controls?.find(c => c.name === 'WorkOrder');
            control?.setValue(CtSelectControlValue.create().setValue(dataSource.WorkOrder.Oid).setLabel(dataSource.WorkOrder?.Name ?? null));

            const titleParts = [
              'Progetto',
              dataSource.WorkOrder.Name,
              dataSource.WorkOrder?.Company?.DisplayName
            ].filter(Boolean);

            const title = titleParts.join(' - ');

            // Aggiorna il titolo nei route data
            this.route.data.pipe(take(1)).subscribe(data => {
              data['title'] = title;
              data['urls'] = ['task'];
              this.cdr.detectChanges();
            });


          }

          if (dataSource.SystemUser) {

            const control = this.mainConfiguration?.controls?.find(c => c.name === 'SystemUser');
            control?.setValue(CtSelectControlValue.create().setValue(dataSource.SystemUser.Oid).setLabel(dataSource.SystemUser?.NameSurname ?? null));

          }
          
          if (dataSource.State) {

            const control = this.mainConfiguration?.controls?.find(c => c.name === 'State');
            control?.setValue(dataSource.State.Oid);

          }

          if (dataSource.Type) {

            const control = this.mainConfiguration?.controls?.find(c => c.name === 'Type');
            control?.setValue(CtSelectControlValue.create().setValue(dataSource.Type.Oid).setLabel(dataSource.Type?.Name ?? null)).setDisabled(true);

            if (dataSource.Type.MacroType == TaskType.ResearchSelection)
              this.createLeadTaskModelConfiguration(dataSource.Oid);

          }

        }
      });
  }

  createLeadTaskModelConfiguration(taskOid: number) {

    this.taskLeadModelConfiguration = CtModelConfiguration.create()
      .setCTDatatableConfiguration(DEFAULT_DATATABLE_CONFIGURATION())
      .setRouteData(TaskLeadRouteData())
      .setOnCreate(() => this.openDialogTaskLead(TaskLeadEditConfiguration.create().setTaskOid(taskOid)))
      .setOnEdit((event: any) => this.openDialogTaskLead(TaskLeadEditConfiguration.create().setTaskOid(taskOid).setData(event)))
      .setOnDetail((event: any) => {

        if (event.Lead?.Oid)
          this.router.navigate(['lead', 'edit', event.Lead?.Oid]);

      })

    this.taskLeadModelConfiguration
      .initialized()
      .subscribe(() => this.taskLeadModelConfiguration?.setOperations([CtModelOperator.Detail, CtModelOperator.Create, CtModelOperator.Update]));

    this.taskLeadModelConfiguration.filterValues
      .addConstantFilter(CTModelDatatableFilter.create()
        .setField('Task.Oid')
        .setValue(taskOid)
        .setOperatorType(CtBinaryOperator.Equal))

  }

  private openDialogTaskLead(taskLeadConfiguration: TaskLeadEditConfiguration) {

    this.dialog.open(LeadSelectionComponent, {
      data: null,
      width: '70vw'
    }).afterClosed().subscribe(async (result: any) => {

      if (result.length > 0) {

        taskLeadConfiguration.setSelectedLead(result[0]);
        this.taskService.createTaskLead(taskLeadConfiguration).then(async (result: any) => {

          if (result) {

            window.location.reload();
            this.cdr.detectChanges();

          }

        })

      }

    });


  }

  async addTaskLeadForm(initialData: any = null) {

    this.dialog.open(LeadSelectionComponent, {
      data: null,
      width: '70vw'
    }).afterClosed().subscribe(async (result: any) => {

      if (result.length > 0) {

        const config = await this.generalService.getFormConfiguration(this.formBuilder.group({}), TaskLeadRouteData());

        if (initialData) {
          config.form?.patchValue(initialData);
        }

        const control = config.controls?.find(c => c.name === 'Lead');
        control?.setValue(CtSelectControlValue.create().setValue(result[0].Oid).setLabel(result[0].ReferenceName)).setDisabled(true);
        //Prendo il primo risultato come lead selezionato

        this.taskLeadConfigurations.push(config);
      }

    });


  }

  removeTaskLeadForm(index: number) {

    this.taskLeadConfigurations.splice(index, 1);

  }

  listenToTaskTypeChanges() {

    this.taskTypeSubscription = this.mainConfiguration
      ?.form
      ?.controls['Type']
      .valueChanges
      .subscribe((value: CtSelectControlValue) => {

        const selectedOid = value.value;
        const selectedTaskType = this.taskTypeList.find(tt => tt.Oid === selectedOid);

        this.typeValue = selectedTaskType?.MacroType;

        if (this.typeValue !== TaskType.ResearchSelection)
          this.taskLeadConfigurations = [];

      });

  }

  setupWorkOrder(oid: number) {

    if (!this.mainConfiguration) return;

    const modelConfiguration = CtModelConfiguration.create().setRouteData(WorkOrderRouteData().setId(oid));

    this.modelService.getInfos(modelConfiguration).subscribe({
      next: response => {
        const dataSource = response?.Result?.DataSource;
        if (dataSource) {
          const control = this.mainConfiguration?.controls?.find(c => c.name === 'WorkOrder');
          control?.setValue(CtSelectControlValue.create().setValue(oid).setLabel(dataSource?.Name)).setDisabled(true);

          const titleParts = [
            'Progetto',
            dataSource.Name,
            dataSource.Company?.DisplayName
          ].filter(Boolean);
          //TODO: Gestire traduzione
          const title = titleParts.join(' - ');

          // Aggiorna il titolo nei route data
          this.route.data.pipe(take(1)).subscribe(data => {
            data['title'] = title;
            data['urls'] = ['task'];
            this.cdr.detectChanges();
          });

        }
      },
      error: err => console.error('Errore:', err)
    });

  }

  onSubmit() {

    this.mainConfiguration?.form?.markAllAsTouched();
    this.invoiceConfiguration?.form?.markAllAsTouched();
    this.taskLeadConfigurations?.forEach(config => config.form?.markAllAsTouched());


    if (this.mainConfiguration?.form?.invalid || this.invoiceConfiguration?.form?.invalid || this.taskLeadConfigurations.some(config => config.form?.invalid)) {
      return;
    }

    const mainData = this.mainConfiguration?.form?.getRawValue() || {};
    // Se la sezione "Dati fatturazione" è stata disabilitata via configurazione,
    // `invoiceConfiguration` è null e non c'è nulla da spread-are: al submit i campi
    // Invoice* non vengono inviati e i valori esistenti a DB restano invariati (fix solo FE).
    const invoiceData = this.invoiceConfiguration?.form?.getRawValue() || {};

    const taskData: Task = Task.create({
      ...mainData,
      ...invoiceData  // Se ci sono chiavi in comune, invoiceData le sovrascrive
    });

    const modelConfiguration = CtModelConfiguration.create().setRouteData(TaskRouteData());

    const pId: string | null = this.route.snapshot.paramMap.get("id");
    if (pId) {
      modelConfiguration.RouteData?.setId(+pId);
    }

    if (this.mainConfiguration?.form?.controls['WorkOrder']?.value?.value)
      taskData.setWorkOrderOid(this.mainConfiguration?.form?.controls['WorkOrder']?.value?.value);

    if (this.mainConfiguration?.form?.controls['Type']?.value?.value)
      taskData.setTypeOid(this.mainConfiguration?.form?.controls['Type']?.value?.value);

    if (this.mainConfiguration?.form?.controls['SystemUser']?.value?.value)
      taskData.setSystemUserOid(this.mainConfiguration?.form?.controls['SystemUser']?.value?.value);

  if (this.mainConfiguration?.form?.controls['State']?.value)
      taskData.setStateOid(this.mainConfiguration?.form?.controls['State']?.value);


    const filtered = omitBy(taskData, isNil);   // Mi rimuove i campi null 



    this.modelService.putInfos(modelConfiguration, filtered)?.pipe(
      // 2) Alla risposta, decide se mandare anche i TaskLead
      switchMap((mainRes: CtWebapiGenericResponse<number>) => {
        // Se non è HR, salto direttamente alla navigation
        if (this.typeValue !== TaskType.ResearchSelection) {
          return of({ mainRes, leadsRes: null });
        }

        // Preparo l'array di Task_Lead da salvare
        const leadsData: Task_Lead[] = this.taskLeadConfigurations.map(config => {

          config.form?.markAllAsTouched();
          if (config.form?.invalid) {
            throw new Error('Form di Task Lead non valido');
          }

          const raw = config.form?.getRawValue() ?? {};
          const lead = Task_Lead.create(raw)
            .setTaskOid(mainRes.Result);

          const leadControl = config.form?.controls['Lead']?.value;
          if (leadControl?.value) {
            lead.setLeadOid(leadControl.value);
          }

          return lead;
        });

        if (leadsData.length === 0) {
          return of({ mainRes, leadsRes: null });
        }

        // Mappo ogni lead in una chiamata PUT (filtrando i null)
        const calls = leadsData.map(lead => {
          const cfg = CtModelConfiguration.create().setRouteData(TaskLeadRouteData());
          const filteredLead = omitBy(lead, isNil);
          return this.modelService!.putInfos(cfg, filteredLead);
        });

        // forkJoin aspetta che TUTTE le chiamate finiscano
        return forkJoin(calls).pipe(
          // restituisco sia il risultato principale sia i risultati dei lead
          map(leadsRes => ({ mainRes, leadsRes }))
        );
      })
    )
      .subscribe({
        next: ({ mainRes }) => {
          // 3) Navigation solo quando tutto è completato
          const typeParam = this.route.snapshot.queryParamMap.get('TypeExtra');
          const oidParam = this.route.snapshot.queryParamMap.get('OidExtra');
          let param: EventPathParam | null = null;
          if (typeParam && oidParam) {
            param = EventPathParam.create(+oidParam, +typeParam);
          }

          if (param) {
            this.router.navigate([this.generalService.getPathToReturn(+param.Type!), 'edit', param.Oid]);
          } else {
            this.router.navigate(['task', 'edit', taskData.Oid ?? mainRes.Result]);
          }
        },
        error: err => {
          console.error('Errore durante il salvataggio:', err);
        }
      });

  }


  ngOnDestroy() {
    this.taskTypeSubscription?.unsubscribe();
  }

}
